import React from "react";
import { FlexCenter } from "../../../../../layout/FlexCenter/FlexCenter";
import { SpacingCustom } from "../../../../../layout/Spacing/SpacingCustom";
import { ExecButton } from "../../../../../ui/ExecButton/ExecButton";
import { clearFiles } from "../BlobStorage/fileList.slice";
import { fetchInFlowTransferPeding } from "../InFlowTransfer/inFlowTransfer.slice";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { rootState } from "../../../../../../redux/store";

export const AiAnalyzerBottomButtons: React.FC = () => {
    const { neo4jResultLoading, neo4jResultData, neo4jResultError } = useAppSelector((state: rootState) => state.inFlowTransfer);
    const dispatch = useAppDispatch();
    
    return(
        <div style={{ position: 'absolute', width: '100%', bottom: '0', left: '0', zIndex: '1' }}>
            <SpacingCustom paddingLeft={0.5} paddingRight={0.5} paddingBottom={0.5}>
                <FlexCenter position="end" direction="v" gap={0.3}>
                    <ExecButton
                        isLoading={neo4jResultLoading ? true : false}
                        stretch
                        showIcon
                        label={'Create InFlow Assets'}
                        iconName={'Edit'}
                        func={() =>
                            dispatch(
                                fetchInFlowTransferPeding({
                                    url: `${process.env.REACT_APP_CREATE_INFLOW_ASSET}`,
                                    token: '',
                                }),
                            )
                        }
                    />
                    <ExecButton stretch showIcon label={'Clean list'} iconName={'Edit'} func={() => dispatch(clearFiles())} />
                </FlexCenter>
            </SpacingCustom>
        </div>
    )
}